import { getExt } from 'pano-utils';
import { LibApiType, QiniuTokenType } from '@types';
import { $member } from '@stores/memberStores';
import uploadToQiniu from './uploadToQiniu';
import getFileMd5 from './getFileMd5';

async function uploadVideoCover(file: File) {
  const { uid } = $member.getState().property!;
  const prefix = `/${uid}/${LibApiType.image}`;
  const md5 = await getFileMd5(file);
  const key = `${prefix}/${md5}v5.${getExt(file.name)}`;
  return uploadToQiniu({
    tokenType: QiniuTokenType.media,
    file,
    key,
  });
}

export default uploadVideoCover;
